import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ProposalRequestModule = lazy(loadModule);

export default ProposalRequestModule;
